import styled from 'styled-components';
import { getSpace } from '@stylesheets/tools';

const StyledDateDetails = styled.div`
  .container__wrapper {
    margin-bottom: 80px;
  }

  .dateDetails__more-btn {
    margin: auto;
    margin-top: ${getSpace('xxl')};
    width: max-content;

    svg {
      margin-left: ${getSpace('xxs')}
      width: 55px;
    }
  }

  .dateDetails__further-teaser--no-results .dateDetails__more-btn {
      margin-left: unset;
      margin-top: ${getSpace('m')};
  }

  .filterResults__container .container__wrapper {
    margin-left: unset;
    margin-right: unset;
  }
`;

export default StyledDateDetails;
